import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import { CourseOverviewCostFields } from './CourseOverviewCostFields';

import styles from './CourseOverviewCost.module.css';

type CourseOverviewCostProps = ComponentProps & {
	fields: {
		items: CourseOverviewCostFields[];
	};
};

export default function CourseOverviewCost(props: CourseOverviewCostProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const isEditing = IsSitecoreEditing();

	if (isEditing && (!props.fields?.items || props.fields?.items.length === 0)) {
		return (
			<section className="maxWidth padX padYL">
				<EditorHelp
					text={
						'To display Costs for this course, view this course in the Content Editor and create a Cost in the Costs folder underneath.'
					}
				/>
			</section>
		);
	}

	return (
		<>
			<EditorHelp
				text={
					'To change the order of the Costs for this course, view this course in the Content Editor and go to the Costs folder underneath.'
				}
			/>
			{isEditing ||
				(props.fields?.items?.length > 0 && (
					<div className="maxWidth">
						<ContentOverviewHeaderContainer
							header={props.fields?.items?.length > 1 ? sitecoreContext.dictionary.costsTitle : sitecoreContext.dictionary.costTitle}
						/>

						<div className={styles.costComponentContainer}>
							{props.fields?.items.map((costItem, index) => (
								<div key={index} className={props.fields?.items?.length > 1 ? styles.costItemContainers : ''}>
									{props.fields?.items?.length > 1 && <Text tag="h4" field={costItem.fields?.CostTitle} className={styles.costTitle} />}
									<span className={styles.costPlusVat}>
										<Text tag="h2" field={costItem.fields?.Cost} className={styles.cost} />
										{costItem.fields?.PlusVat?.value && <Text tag="span" field={costItem.fields?.PlusVatText} className={styles.plusVat} />}
									</span>
									<Text tag="p" className={styles.costSubtitle} field={costItem.fields?.CostDescription} />
								</div>
							))}
						</div>
					</div>
				))}
		</>
	);
}
